import { styled } from 'goober';
import React, { ForwardedRef, forwardRef, HTMLAttributes, ReactNode } from 'react';
import { FaChevronDown, FaChevronRight } from 'react-icons/fa';

const Container = styled('div', forwardRef)`
    cursor: pointer;
    font-size: ${(props) => props.theme.font.size};
    color: ${(props) => props.theme.colors.ui.dark};
    display: flex;
    align-items: center;
    justify-content: start;

    & > span {
        cursor: pointer;
        margin-left: 15px;
    }
`;

interface FormSectionProps extends HTMLAttributes<HTMLDivElement> {
    show?: boolean;
    title: string;
    children: ReactNode;
}

function FormSection(props: FormSectionProps, ref: ForwardedRef<HTMLDivElement>) {
    const { show = false, title, children, ...rest } = props;
    const Icon = show ? FaChevronDown : FaChevronRight;
    return (
        <>
            <Container {...rest} ref={ref}>
                {title}
                <span>
                    <Icon size={10} />
                </span>
            </Container>
            {show && children}
        </>
    );
}

export default forwardRef(FormSection);
